const serverDomain = process.env.REACT_APP_SERVER_DOMAIN;
console.log("Server Domain:", serverDomain);

const APIEndPoints = {
  sign_up: {
    url: `${serverDomain}/api/auth/sign-up`,
  },
  sign_in: {
    url: `${serverDomain}/api/auth/sign-in`,
  },
  sign_out: {
    url: `${serverDomain}/api/auth/sign-out`,
  },
  downloadCV: {
    url: `${serverDomain}/api/files/download-cv`,
  },
  uploadCV: {
    url: `${serverDomain}/api/files/upload-cv`,
  },
  deleteCV: {
    url: `${serverDomain}/api/files/delete-cv`,
  },
  contactUS: {
    url: `${serverDomain}/api/contacts/add`,
  },
  contactUSList: {
    url: `${serverDomain}/api/contacts/list`,
  },
  contactUsDelete: {
    url: `${serverDomain}/api/contacts/delete`,
  },
  skills: {
    url: `${serverDomain}/api/skills`,
  },
  services: {
    url: `${serverDomain}/api/services`,
  },
  workinghistory: {
    url: `${serverDomain}/api/working-history`,
  },
  educationhistory: {
    url: `${serverDomain}/api/education-history`,
  },
  myprojects: {
    url: `${serverDomain}/api/projects`,
  },
  workwithme: {
    url: `${serverDomain}/api/workwithme`,
  },
  client_reviews: {
    url: `${serverDomain}/api/clientreviews`,
  },
  get_categories: {
    url: `${serverDomain}/api/categories`,
  },
  get_blogs: {
    url: `${serverDomain}/api/blogs`,
  },
  latestproject: {
    url: `${serverDomain}/api/projects/latest`,
  },
};

export default APIEndPoints;
